import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom'

const ProtectiedAfterAuth = ({ children }) => {

    const isUserAuthenticated = useSelector((store) => store?.authStates?.isUserAuthenticated);
    // if (isUserAuthenticated) {

    //     return <Navigate to={'/dashboard'} replace />
    // }
    // else {
    //     return children;
    // }
    return children;
}

export default ProtectiedAfterAuth;